import React from 'react'
import {Spin, Tooltip, message, Space, Button, Select, Input, Modal} from 'antd';
import EssaModal from '@components/EssaModal/EssaModal';
import PageCommon from  "@components/PageCommon/PageCommon";
import AuthBtn from "@components/HoverIcon/AuthBtn";
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import { Link } from "react-router-dom"
import Lang from "@components/Lang/Lang";
import {postDeliveryList, postDeliveryListInfo, postBatchDelivery,downloadDeliverOrder} from '@/api/warehouseManagement/outWarehouse';
import {postWaitIntoWarehouseList, postInserIntoWarehouse} from '@/api/warehouseManagement/registration'
import LogisticsAndCabinetSwitch from "@/components/Logistics/LogisticsAndCabinetSwitch";
import { toFixedWithCommas} from "@utils/number-util";
import dayjs from 'dayjs';
import IconDirectPo from "@components/Icon/IconDirectPo/IconDirectPo";//直达图标
import OrderDetails from '../../../../../components/ModalOrderDetails/OrderDetails/index';
const { Option } = Select;
/**
 * 待出库 页签 | 使用统一的 查询表格组件
 *
 * @author FJJ
 * @version 2.0
 *
 * History:
 * Date      Version Remarks
 * ========= ======= ======================================================
 * 2022      1.0     First version Zhaoruji  => 备份在 index.bak.js
 * 2023      2.0    FJJ
 *
 *
 * @copyright 2021-2021, all rights reserved. Essa.cn
 * */
export default class WaitTable extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isModalVisible: false,
            loading: false,
            list:[],//行
            extra: {},
            selectOrder:{},
            // 搜索默认
            searchStatus:0,
            // 表单 配置
            searchFormOptions:[
                {
                    name:'transitCityIds',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'所有仓库',
                    cnPlaceholderId:'SuoYouCangKu',
                    type:'WarehouseSelect',
                },
                {
                    name:'orderNumber',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'订单编号',
                    cnPlaceholderId:'DingDanBianHao',
                    width:216,
                },
                {
                    name:'buyerNumber',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'客户编号',
                    cnPlaceholderId:'KeHuBianHao',
                    width:216,
                },
            ],
            columns:[
                {
                    cnTitle: '客户编号',
                    cnTitleId: 'KeHuBianHao',
                    dataIndex: 'buyerNumber',
                    render:(text, record, index) => (
                       record.buyerId?<Link className="num" to={`/customer/detail?id=${record.buyerId}`}>{text}</Link>:text
                    ),
                },
                {
                    cnTitle: 'PO单号',
                    dataIndex: 'orderNumber',
                    width: 220,
                    cnTitleId: 'PODingDan',
                    render:(code, record, index) => (<>
                        <p className={"black89 font-bold"}>{code}
                        {record.noCertificateSplit==1?<Tooltip title={Lang({id: "ZhongGuoZhiFaDingDan",default: "中国直发订单"})}><span className={"ml_4"}>
                                            <IconDirectPo size={18}></IconDirectPo>
                                        </span>
                        </Tooltip>:null}
                        </p>
                        {record.orderNumber&&<LogisticsAndCabinetSwitch poId = {record.id}
                            poCode={record.orderNumber}
                            containerCode={record.containerCode}
                            cabinetNum={record.cabinetNum}
                            logisticsData={record.pubOrderTrackVOS}
                        />}
                    </>)
                },
                {
                    cnTitle: '商品信息',
                    dataIndex: 'poCreateTime',
                    cnTitleId: 'ShangPinXinXi',
                    render:  (text, record, index) => (
                        <span>{record.skuNum}{Lang({id:'Kuan', default:'款'})}，{record.quantity}{Lang({id: 'Xiang', default: '箱'})}</span>
                    )
                },
                {
                    cnTitle: '收货人信息³',
                    dataIndex: 'consignee',
                    cnTitleId: 'ShouHuoRen',
                    width:300,
                    render:(text, record, index) => (
                    <Space direction="vertical ">
                        <div>{record.consignee||record.deliveryContactName}</div>
                        <div className="subhead">{record.address||record.deliveryContactMobile}</div>
                    </Space>
                    )
                },
                {
                    cnTitle: '所在仓库',
                    cnTitleId: 'SuoZaiCangKu',
                    dataIndex: 'fromWarehouseName',
                },
                {
                    cnTitle: '时间',
                    cnTitleId: 'ShiJian',
                    dataIndex: 'time',
                    render:(text, record, index) => (<>
                        <p>
                            <Tooltip placement="left" title={Lang({id: 'RuKuShiJian', default: '入库时间'})}>
                                <i className="ri-calendar-check-line mr_6 color-green"></i>
                                {record.deliveryTime ? dayjs(record.deliveryTime).format('YYYY-MM-DD') : '-'}
                            </Tooltip>
                        </p>
                   </> )
                },
                {
                    cnTitle: '操作',
                    dataIndex: 'CaoZuo',
                    width: 60,
                    cnTitleId: 'CaoZuo',
                    render: (item = {}, record) => (<div >
                        <AuthBtn icon={"ri-article-line"} tips = {Lang({id:"XiangQing",default:"详情"})}
                                       onClick={()=>this.getDeliveryListInfo(record.id)}/>
                    </div>)},
            ],
            showTip: false,// 批量提示出库提示
        }
        this.intoWarehouseInfo = {}
    }
    loading(flag){
        this.setState({
            loading: flag
        })
    }
    /**
     * 获取单个出库详情*/
    getDeliveryListInfo(id) {
        this.loading(true)
        this.handleCloseDetails(true)
        postDeliveryListInfo({
            id,
        }).then(res => {
            if (res.data.success && res.data.valid) {
                let order = res.data.model || {}
                this.setState({
                    selectOrder: {
                        ...order,
                        ids: [order.id],
                    },
                    extra: res.data.extra,
                })
            } else {
                message.info(res.data.message);
            }
            this.loading(false)
        })
    }
    handleCloseDetails(flag=false){
        this.setState({
            showDetails:flag
        })
    }
    setInputKey(key,str){
        let curr = this.state;
        curr[key] = str;
        this.setState(curr)
    }
    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref;
    onRefTabOne = (ref) =>  this.onPageTemplateTableChild = ref;
    // 查询回调
    fetchCallBack(res){
        this.onRefPageCommonChild.isShowTop()
        const {success,valid,models,model} = res;
        if (success && valid) {
            this.setState({
                list: models
            })
            this.props.setNum(model||0)
        }else {
            this.props.setNum(0)
            this.setState({
                list: []
            })
        }
    }
    // 选择表格行
    setSelectedRowKeys(ids){
        this.setState({
            selectedRowKeys:ids
        })
    }
    onSelectChange = (newSelectedRowKeys) => {
        this.setSelectedRowKeys(newSelectedRowKeys);
    };
    onClick(type=""){
        const { selectedRowKeys,list } = this.state;
        if(selectedRowKeys&&selectedRowKeys.length>0){
            if(type=="batchDelivery"){
                let selectOrder = {
                    quantity: 0, // 商品箱数
                    skuNum: 0, // 商品款数
                }
                selectedRowKeys.forEach(item => {
                    const obj = list.find(row=>row.id==item)||{}
                    selectOrder.quantity += (obj.quantity||0)
                    selectOrder.skuNum += (obj.skuNum||0)
                })
                this.setState({
                    selectOrder,
                })
                this.openBatchDelivery(true);
            }else if(type=="batchDoc"){
                this.loading(true)
                downloadDeliverOrder({ids:selectedRowKeys}).then((res={})=>{
                    const {success,valid,model} = res.data||{};
                    if(success&&valid&&model){
                        this.setSelectedRowKeys([]);
                        if(model.fileUrl){
                            window.open(model.fileUrl)
                        }
                    }
                    this.showTimer =  setTimeout(()=>{
                        this.loading(false)
                    },600)

                })
            }else message.warning("未定义方法")
        }else message.warning(Lang({id:"QingXuanZeYaoCaoZuoDeShuJu",default:"请选择要操作的数据"}))

    }
    /**
     * 出库确认*/
   openBatchDelivery(flag=false){
        this.setState({
            showTip: flag,
        })
    }
    batchDelivery() {
       this.loading(true)
       const { selectedRowKeys } = this.state;
        postBatchDelivery({
            ids: selectedRowKeys || []
        }).then((res={ }) => {
            this.loading(false);
            const data = res.data||{};
            const { success,valid, } = data;
            if (success && valid) {
                message.success(Lang({id:"ChuKuChengGong",default:"出库成功"}));
                this.onPageTemplateTableChild.handleFetch(1,{},true)
                this.openBatchDelivery()
            } else if (!success) {
              if(data.message){
                  message.info(data.message);
              }else message.info(Lang({id:"CaoZuoShiBai",default:"操作失败"}));
            }

        })
    }
    componentWillUnmount = () => {
        this.setState = (state, callback) => {
            return;
        };
        if(this.showTimer)clearTimeout(this.showTimer)
    };
    render() {
        const {loading, columns,searchFormOptions, selectedRowKeys, searchStatus, showTip, consignee, showDetails, extra,selectOrder} = this.state;
        // const [selectedRowKeys, setSelectedRowKeys] = useState([]);
        return (<PageCommon onRef={this.onRefPageCommon}
                            loading={loading}
                            btnList={[
                {
                    btn: Lang({id:"ChuHuo",default:"出货"}),
                    icon:"ri-share-forward-line mr_4 color-blue",
                    btnClick:()=>this.onClick("batchDelivery")
                },{
                    btn: Lang({id:"ShengChengDanJu",default:"生成单据"}),
                    icon:"ri-file-excel-2-line color-green mr_4",
                    btnClick:()=>this.onClick("batchDoc")
                }
            ]}>
                 <AutoFetchTable columns={columns}
                                 onRef={this.onRefTabOne}
                                 fetchCallBack={(data)=>this.fetchCallBack(data)}
                                topSearchLeftCont={(<Input style={{width:"392px"}}
                                                           className={"mr_12"}
                                                           addonBefore={<Select value={searchStatus} style={{width:"136px"}} onSelect={(value)=>this.setInputKey("searchStatus", value||0)}>
                                                                <Option value={0}>{Lang({id:"ShouHuoRenXingMing",default:"收货人姓名"})}</Option>
                                                                <Option value={1}>{Lang({id:"ShouHuoRenShouJi",default:"收货人手机"})}</Option>
                                                            </Select>}
                                                           placeholder={Lang({id:"QingShuRu",default:"请输入"})}
                                                           onChange={(e)=>this.setInputKey("consignee",e.target.value,)}
                                    />)}
                                rowSelection={{
                                    selectedRowKeys,
                                    onChange: this.onSelectChange,
                                }}
                                flagShowReset={false}
                                precondition={{searchStatus: searchStatus,consignee: consignee,isDelivery:0}}
                                pageSize={50}
                                searchFormOptions={searchFormOptions}
                                fetchApi={'/service/mg/delivery-management/delivery-list'} />
                {/*出库详情弹窗*/}
                {showDetails&&<EssaModal title={Lang({id:"DingDanXiangQing",default:"订单详情"})}
                                         open={showDetails}
                                         key={"rx"}
                                         width={750}
                                         onCancel={()=>this.handleCloseDetails()}
                                         footer={[
                                           <Button onClick={() => this.handleCloseDetails()} key={"close"}>
                                              {Lang({id:"GuanBi",default:"关闭"})}
                                           </Button>,
                                       ]}
                >
                    <Spin spinning={loading}>
                       {selectOrder&&selectOrder.orderNumber&&extra.currencySymbol&&<OrderDetails
                           data={selectOrder}
                           currencySymbol={extra.currencySymbol} />}
                    </Spin>
                </EssaModal>}
                {showTip&&<EssaModal title={Lang({id:"PiLiangChuHuo",default:"批量出货"})}
                                     open={showTip}
                                     onCancel={()=>this.openBatchDelivery(false)}
                                     onOk={()=>this.batchDelivery()}>
                    <Spin spinning={loading}>
                    <p>{selectedRowKeys.length>0?Lang({id:"QueRenSuoXuanDingDan",default:"确认所选{0}个订单",params:[selectedRowKeys.length]}):Lang({id:"QueRenDingDan",default:"待确认订单"})}
                        {Lang({id:"HeJi",default:"合计"})}
                        {this.state.selectOrder.skuNum}
                        {Lang({id:"Kuan",default:"款"})}，
                        {this.state.selectOrder.quantity}
                        {Lang({id:"Xiang",default:"箱"})}。{Lang({id:"AnPaiChuHuo",default:"安排出货"})}？</p>
                    </Spin>
                </EssaModal>}
            </PageCommon>
        )
    }
}